import { useIsDesignLanguage, DesignLanguage } from '@afterpaytouch/core'
import { useInlineArcadeComponentsEnabled, useSummaryImprovementsExperiment } from '../../state'
import { useRouter } from 'next/router'
import { Route } from '../../config/router'

export const useShowAvatarInHeader = (): boolean => {
  const isArcadeDesign = useIsDesignLanguage(DesignLanguage.Arcade)
  const { enabled: summaryImprovementsEnabled, value: summaryImprovementsVariant } = useSummaryImprovementsExperiment()
  const isValidVariant = summaryImprovementsVariant === 'B' || summaryImprovementsVariant === 'E'

  return !isArcadeDesign && summaryImprovementsEnabled && isValidVariant
}

export const useHideDividerForInlineArcadeComponents = (): boolean => {
  const router = useRouter()
  const isNewPaymentMethodPage = router.pathname === Route.NEW_PAYMENT_METHOD
  const isInlineArcadeComponentEnabled = useInlineArcadeComponentsEnabled(false)
  return isNewPaymentMethodPage && isInlineArcadeComponentEnabled
}
